import { InputGroup, SexSelect } from "#common";
function IntakeInformation({ animal, onChange }) {
  return !animal ? (
    <div />
  ) : (
    <div className="flex flex-col gap-2">
      <InputGroup
        type="date"
        label="Intake Date"
        value={animal.intakeDate}
        onChange={onChange}
      />
      <InputGroup label="Source" value={animal.source} onChange={onChange} />
    </div>
  );
}
export default IntakeInformation;
